import { Component, OnInit, Sanitizer, OnDestroy, Input } from "@angular/core";
import PerfectScrollbar from "perfect-scrollbar";
import { AutenticacaoService } from "../services/autenticacao.service";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { NotificacaoService } from "../services/notificacao.service";
import { CarregandoService } from "../services/carregando.service";
import { DashboardRoutes } from "../dashboard/dashboard.routing";
import { GlobalService } from "../services/global.service";
import { Subscription } from "rxjs";
import { Configuracao } from "../models/configuracao";
import { PremissasService } from "../services/premissas.service";
import { FuncionarioService } from "../services/funcionario.service";
import { TelaDoFuncionario } from "../models/tela-do-funcionario";
import { SegmentacaoService } from "../services/segmentacao.service";
import { IdentidadeVisualService } from "../services/identidade-visual.service";
import { ClienteService } from "../services/cliente.service";
import { Cliente } from "../models/cliente";
import { UsuarioLogado } from "../models/usuario-logado";
import { PremissasSistema } from "../models/premissas-sistema";
import { RZKService } from "../services/rzk.service";
import { FinanciamentoService } from "../services/financiamento.services";
import { Financiamento } from "../models/financiamento/financiamento";
import { FinSimulacaoService } from "../services/fin-simulacao.service";
import { LojaConfigService } from "../loja-gi/services/loja-config.service";
import { GiLojaModel } from "../dominio/gi-loja-model";
import { QueryFilterService } from "../core/services/query-filter-service";
import { TipoSituacaoCadastral } from "../dominio/enums";
import { GridfyFilter } from "../core/models/gridfy-filter";

declare const $: any;

const caminhoImagensCustomizadas = "./assets/img/customizadas/";

// Metadata
export interface RouteInfo {
  path?: string;
  title?: string;
  type?: string;
  icontype?: string;
  collapse?: string;
  children?: ChildrenItems[];
  caminhoImagem?: string;
  botao?: boolean;
  metodo?: string;
  visivel?: boolean;
  somenteMobile?: boolean;
  traco?: boolean;
  hint?: string;
}

export interface ChildrenItems {
  path: string;
  title: string;
  ab: string;
  type?: string;
  metodo?: string;
  visivel?: boolean;
}

// Menu Items
export const GI_ROUTES: RouteInfo[] = [
  {
    path: "",
    title: "Usuário",
    type: "sub",
    icontype: "person",
    collapse: "usuario",
    somenteMobile: true,
    children: [],
  },
  {
    path: "/home",
    title: "Home",
    type: "link",
    icontype: "home",
  },
  {
    path: "/dashboard",
    title: "Dashboard",
    type: "link",
    icontype: "dashboard",
  },
  // {
  //   path: '/montar-kit',
  //   title: 'Montar Kit',
  //   type: 'link',
  //   icontype: 'calculate',
  //   // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  // },
  {
    path: "/montar-kit",
    title: "Monte seu Kit",
    type: "link",
    icontype: "calculate",
    // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  },
  // {
  //   path: '/kitmanual',
  //   title: 'Montar Kit Manual',
  //   type: 'link',
  //   icontype: 'calculate',
  //   // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  // },
  {
    path: "/kitfechado",
    title: "Kit Fechado",
    type: "link",
    icontype: "list_alt",
    // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  },
  {
    path: "/kitplus",
    title: "Kit Plus",
    type: "link",
    icontype: "inventory_2",
    // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  },
  {
    path: "/kitplus2",
    title: "Kit Plus 2",
    type: "link",
    icontype: "inventory_2",
    // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  },
  {
    path: "/loja-de-produtos",
    title: "Loja de Produtos",
    type: "link",
    icontype: "storefront",
  },
  {
    path: "/kitpersonalizado",
    title: "Personalize seu kit",
    type: "link",
    icontype: "fact_check",
    visivel: false,
    // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  },
  {
    path: "/avulso",
    title: "Avulso",
    type: "link",
    icontype: "fact_check",
    // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  },
  {
    path: "/financiamento/monitor-simulacao",
    title: "Financiamentos",
    type: "link",
    icontype: "account_balance",
  },
  {
    traco: true,
  },
  {
    path: "/crm-vendas/acompanhamento",
    title: "CRM Vendas",
    type: "link",
    icontype: "cases",
    hint: "CRM Vendas",
  },
  {
    path: "/crm/oportunidades",
    title: "CRM Integrador",
    type: "link",
    icontype: "table_chart",
    // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  },
  {
    path: "/crm/atividades",
    title: "Atividades",
    type: "link",
    icontype: "style",
    // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  },
  {
    path: "/gestao-tarefas/acompanhamento/hoje",
    title: "Tarefas",
    type: "link",
    icontype: "playlist_add_check",
  },
  {
    traco: true,
  },
  {
    path: "/orcamentos",
    title: "Orçamentos",
    type: "link",
    icontype: "assignment",
    // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  },
  {
    path: "/pedidos",
    title: "Pedidos",
    type: "link",
    icontype: "assignment",
    // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  },
  {
    path: "/classificacao-pedidos",
    title: "Classificação Pedidos",
    type: "link",
    icontype: "insert_chart_outlined",
    // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  },
  {
    path: "/contatos",
    title: "Contatos",
    type: "link",
    icontype: "assignment_ind",
    // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  },
  {
    path: "/integradores",
    title: "Integradores",
    type: "link",
    icontype: "contacts",
    // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  },
  {
    path: "/carteira-de-integradores",
    title: "Carteira Integradores",
    type: "link",
    icontype: "folder_shared",
    // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  },
  {
    path: "/feed-integradores",
    title: "Feed Integradores",
    type: "link",
    icontype: "folder_shared",
    // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  },
  {
    traco: true,
  },

  // {
  //   path: '/etapas',
  //   title: 'Etapas',
  //   type: 'link',
  //   icontype: 'label_important',
  //   // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  // },
  // {
  //   path: '/modelos-de-email',
  //   title: 'Modelos de Email',
  //   type: 'link',
  //   icontype: 'email',
  //   // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  // },

  // {
  //   path: '/usuarios',
  //   title: 'Usuários',
  //   type: 'link',
  //   icontype: 'people',
  //   // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  // },
  {
    path: "/simulacoes",
    title: "Simulações",
    type: "link",
    icontype: "account_balance",
    hint: "Simulações de Financiamento",
  },
  {
    path: "/financiamento/acompanhamento",
    title: "Acompanhamento",
    type: "link",
    icontype: "important_devices",
    hint: "Acompanhamento de Financiamento",
  },
  {
    traco: true,
  },
  {
    path: "/analise-desconto",
    title: "Análise Desconto",
    type: "link",
    icontype: "percent",
  },
  {
    path: "/monitoramento-vendas",
    title: "Monitor Vendas",
    type: "link",
    icontype: "shopping_cart",
  },
  {
    path: "/monitoramento-conferencia",
    title: "Monitor Conferência",
    type: "link",
    icontype: "checklist_rtl",
  },
  {
    path: "/monitoramento-verificacao",
    title: "Monitor Verificação",
    type: "link",
    icontype: "fact_check",
  },
  {
    path: "/monitoramento-analise-financeira",
    title: "Monitor Análise Financeira",
    type: "link",
    icontype: "local_atm",
  },
  {
    path: "/monitoramento-integracao",
    title: "Monitor Integração",
    type: "link",
    icontype: "assignment_turned_in",
  },
  {
    path: "/monitoramento-triagem",
    title: "Monitor Triagem",
    type: "link",
    icontype: "filter_list",
  },
  {
    path: "/monitoramento-pendencia",
    title: "Monitor Pendências",
    type: "link",
    icontype: "pending_actions",
  },
  {
    path: "/monitoramento-financiamento",
    title: "Monitor Financiamento",
    type: "link",
    icontype: "payment",
  },
  {
    path: "/monitoramento-financeiro",
    title: "Monitor Financeiro",
    type: "link",
    icontype: "attach_money",
  },
  {
    path: "/monitoramento-faturamento-tec",
    title: "Monitor Faturamento",
    type: "link",
    icontype: "price_check",
  },
  {
    path: "/monitoramento-separacao",
    title: "Monitor Separação",
    type: "link",
    icontype: "request_quote",
  },

  {
    path: "/monitoramento-faturamento",
    title: "Monitor Fiscal",
    type: "link",
    icontype: "shopping_bag",
  },

  {
    path: "/monitoramento-expedicao",
    title: "Monitor Expedição",
    type: "link",
    icontype: "local_shipping",
  },
  {
    path: "/monitoramento-pedidos",
    title: "Monitor Pedidos",
    type: "link",
    icontype: "list_alt",
  },
  {
    traco: true,
  },
  {
    path: "/fidelidade",
    title: "Programa de Fidelidade",
    type: "link",
    icontype: "emoji_events",
    // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  },
  {
    path: "/repasses",
    title: "Repasses",
    type: "link",
    icontype: "price_check",
    // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  },
  {
    path: "/minhas-ocorrencias",
    title: "Minhas Ocorrências",
    type: "link",
    icontype: "recent_actors",
    // caminhoImagem: caminhoImagensCustomizadas + 'cadastro.svg',
  },
  {
    path: "/fechamento-financeiro",
    title: "Fechamento Financeiro",
    type: "link",
    icontype: "payment",
  },
  {
    path: "/controle-ocorrencia",
    title: "Controle Ocorrências",
    type: "link",
    icontype: "dns",
  },
  {
    path: "/energy-advisor",
    title: "Energy Advisor",
    type: "link",
    icontype: "bolt",
  },
  {
    traco: true,
  },
  {
    path: "/notificacao/central-notificacao",
    title: "Notificações",
    type: "link",
    icontype: "notifications",
  },
  {
    traco: true,
  },
  {
    path: "/relatorios",
    title: "Relatórios",
    type: "link",
    icontype: "description",
  },
  {
    path: "/configuracoes",
    title: "Configurações",
    type: "link",
    icontype: "description",
  },

  {
    path: "/login",
    // botao: true,
    // metodo: 'sair',
    title: "Sair",
    type: "link",
    icontype: "date_range",
    caminhoImagem: caminhoImagensCustomizadas + "sair.svg",
  },
];

@Component({
  selector: "app-sidebar-cmp",
  templateUrl: "sidebar.component.html",
  styleUrls: ["sidebar.component.scss"],
})
export class SidebarComponent implements OnInit, OnDestroy {
  codEverest;

  ROUTES: RouteInfo[];
  ANGULAR_ROUTES: any;

  caminhoSistema = "";

  cliente: Cliente;

  premissasSistema: PremissasSistema;

  public menuItems: any[];
  public menuItemsMobile: any[];
  ps: any;

  nomeDoUsuario = "";
  foto = "";
  administrador = false;

  private configuracaoSubscription$: Subscription;
  configuracao: Configuracao;

  telasDoFuncionario: TelaDoFuncionario[] = [];

  financiamento: Financiamento = new Financiamento();

  idIntegrador = 0;
  integrador = false;
  vendedor = false;
  fidelidadeGoSolar = false;

  suporte = false;

  mostrarKitPronto = false;

  idVisual: any;

  modulosAtivos: Number[] = [];

  usuarioLogado: UsuarioLogado;

  usarCRM = false;

  usarLojaProdutos = false;

  possuiRzkId = false;

  lojas: GiLojaModel[] = [];

  constructor(
    public autenticacaoService: AutenticacaoService,
    public dialog: MatDialog,
    private router: Router,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private globalService: GlobalService,
    private premissasService: PremissasService,
    private funcionarioService: FuncionarioService,
    private segmentacaoService: SegmentacaoService,
    private identidadeVisualService: IdentidadeVisualService,
    private clienteService: ClienteService,
    private rzkService: RZKService,
    private financiamentoService: FinanciamentoService,
    private finSimulacaoService: FinSimulacaoService,
    private lojaConfigService: LojaConfigService,
    private queryFilterService: QueryFilterService
  ) {
    this.idVisual = JSON.parse(localStorage.getItem("idVisual"));
  }

  async ngOnInit() {
    await this.buscarPremissaUsarLojaProdutos();
    await this.buscarPremissaUsarCRM();

    this.usuarioLogado = await this.globalService.consultaUsuario();

    this.administrador = await this.globalService.administrador();
    this.integrador = this.autenticacaoService.isIntegrador(this.usuarioLogado.roles);
    this.suporte = await this.globalService.suporte();

    await this.buscarPremissasSistema();

    if (this.premissasSistema.usarLojaProdutos) {
      await this.buscarLojas();
    }

    if (this.premissasSistema.integracaoRZK) {
      await this.consultarPossuiRzkId();
    }

    if (!this.idVisual) {
      this.buscarIdentidadeVisual();
    }
    await this.buscarModulosAtivos();
    await this.buscarCodEverest();
    await this.buscarMostrarKitPronto();

    await this.buscarFinanciamento();

    this.caminhoSistema = "";
    this.ANGULAR_ROUTES = DashboardRoutes;
    this.ROUTES = [...GI_ROUTES];

    if (this.premissasSistema.usarMonitorConferenciaFilaTarefa) {
      if (this.ROUTES.some((p) => p.title === "Monitor Conferência")) {
        this.ROUTES.find((p) => p.title === "Monitor Conferência").path = "/monitoramento-conferencia-fila-tarefa";
      }
    }

    if (this.integrador) {
      this.idIntegrador = this.usuarioLogado.id;
      await this.buscarCliente();
    }

    this.vendedor = this.autenticacaoService.isVendedor(this.usuarioLogado.roles);

    // busca as telas do usuário
    if (!this.integrador) {
      await this.buscarTelasDoFuncionario();
    }

    if (!this.premissasSistema.habilitaOrcamento) {
      if (this.ROUTES.some((p) => p.title === "Orçamentos")) {
        this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Orçamentos")), 1);
      }
    }

    if (!this.integrador) {
      if (!this.telasDoFuncionario.some((t) => t.tela === "loja-de-produtos") || !this.usarLojaProdutos) {
        if (this.ROUTES.some((p) => p.title === "Loja de Produtos")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Loja de Produtos")), 1);
        }
      } else {
        this.criarMenusLojas();
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "dashboard")) {
        if (this.ROUTES.some((p) => p.title === "Dashboard")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Dashboard")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "home")) {
        if (this.ROUTES.some((p) => p.title === "Home")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Home")), 1);
        }
      }

      if (!this.premissasSistema.habilitaMenuMontarKit || !this.telasDoFuncionario.some((t) => t.tela === "montar-kit")) {
        if (this.ROUTES.some((m) => m.path === "/montar-kit")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((m) => m.path === "/montar-kit")), 1);
        }
      }

      if (!this.premissasSistema.habilitaMenuKitPronto || !this.telasDoFuncionario.some((t) => t.tela === "kitfechado")) {
        if (this.ROUTES.some((p) => p.path === "/kitfechado")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.path === "/kitfechado")), 1);
        }
      }

      if (
        !this.premissasSistema.habilitaMenuKitPronto ||
        !this.premissasSistema.usarNovoMenuKitPronto ||
        !this.telasDoFuncionario.some((t) => t.tela === "kitplus")
      ) {
        if (this.ROUTES.some((p) => p.path === "/kitplus")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.path === "/kitplus")), 1);
        }
      }

      if (
        !this.premissasSistema.habilitaMenuKitPronto ||
        !this.premissasSistema.usarKitPlus2 ||
        !this.telasDoFuncionario.some((t) => t.tela === "kitplus2")
      ) {
        if (this.ROUTES.some((p) => p.path === "/kitplus2")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.path === "/kitplus2")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "avulso")) {
        if (this.ROUTES.some((p) => p.path === "/avulso")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.path === "/avulso")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "orcamentos")) {
        if (this.ROUTES.some((p) => p.title === "Orçamentos")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Orçamentos")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "pedidos")) {
        if (this.ROUTES.some((p) => p.title === "Pedidos")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Pedidos")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "classificacao-pedidos")) {
        if (this.ROUTES.some((p) => p.title === "Classificação Pedidos")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Classificação Pedidos")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "contatos")) {
        if (this.ROUTES.some((p) => p.title === "Contatos")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Contatos")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "integradores")) {
        if (this.ROUTES.some((p) => p.title === "Integradores")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Integradores")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "carteira-de-integradores")) {
        if (this.ROUTES.some((p) => p.title === "Carteira Integradores")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Carteira Integradores")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "crm" && this.usarCRM)) {
        if (this.ROUTES.some((p) => p.title === "CRM Integrador")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "CRM Integrador")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "atividades" && this.usarCRM)) {
        if (this.ROUTES.some((p) => p.title === "Atividades")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Atividades")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "monitoramento-conferencia")) {
        if (this.ROUTES.some((p) => p.title === "Monitor Conferência")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Monitor Conferência")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "monitoramento-verificacao")) {
        if (this.ROUTES.some((p) => p.title === "Monitor Verificação")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Monitor Verificação")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "monitoramento-analise-financeira")) {
        if (this.ROUTES.some((p) => p.title === "Monitor Análise Financeira")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Monitor Análise Financeira")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "monitoramento-faturamento-tec")) {
        if (this.ROUTES.some((p) => p.title === "Monitor Faturamento")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Monitor Faturamento")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "monitoramento-integracao")) {
        if (this.ROUTES.some((p) => p.title === "Monitor Integração")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Monitor Integração")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "monitoramento-triagem")) {
        if (this.ROUTES.some((p) => p.title === "Monitor Triagem")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Monitor Triagem")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "monitoramento-pendencia")) {
        if (this.ROUTES.some((p) => p.title === "Monitor Pendências")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Monitor Pendências")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "monitoramento-financeiro")) {
        if (this.ROUTES.some((p) => p.title === "Monitor Financeiro")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Monitor Financeiro")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "monitoramento-financiamento")) {
        if (this.ROUTES.some((p) => p.title === "Monitor Financiamento")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Monitor Financiamento")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "monitoramento-separacao")) {
        if (this.ROUTES.some((p) => p.title === "Monitor Separação")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Monitor Separação")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "monitoramento-faturamento")) {
        if (this.ROUTES.some((p) => p.title === "Monitor Fiscal")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Monitor Fiscal")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "monitoramento-expedicao")) {
        if (this.ROUTES.some((p) => p.title === "Monitor Expedição")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Monitor Expedição")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "monitoramento-pedidos")) {
        if (this.ROUTES.some((p) => p.title === "Monitor Pedidos")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Monitor Pedidos")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "monitoramento-vendas")) {
        if (this.ROUTES.some((p) => p.title === "Monitor Vendas")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Monitor Vendas")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "fidelidade")) {
        if (this.ROUTES.some((p) => p.title === "Programa de Fidelidade")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Programa de Fidelidade")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "repasses")) {
        if (this.ROUTES.some((p) => p.title === "Repasses")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Repasses")), 1);
        }
      }

      if (!this.administrador && !this.integrador && !this.suporte) {
        if (this.ROUTES.some((p) => p.title === "Minhas Ocorrências")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Minhas Ocorrências")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "fechamento-financeiro")) {
        if (this.ROUTES.some((p) => p.title === "Fechamento Financeiro")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Fechamento Financeiro")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "controle-ocorrencia")) {
        if (this.ROUTES.some((p) => p.title === "Controle Ocorrências")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Controle Ocorrências")), 1);
        }
      }

      if (
        !this.premissasSistema.usarAnaliseDeDesconto ||
        !this.telasDoFuncionario.some((t) => t.tela === "analise_desconto")
      ) {
        if (this.ROUTES.some((p) => p.title === "Análise Desconto")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Análise Desconto")), 1);
        }
      }

      if (
        !this.possuiModulo(15) ||
        !this.financiamento.ativo ||
        !this.financiamento.usaControleTarefas ||
        !this.telasDoFuncionario.some((t) => t.tela === "central_simulacao_financiamento")
      ) {
        if (this.ROUTES.some((p) => p.path === "/simulacoes")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.path === "/simulacoes")), 1);
        }
      }

      if (
        !this.possuiModulo(15) ||
        !this.financiamento.ativo ||
        !this.financiamento.usaControleTarefas ||
        !this.telasDoFuncionario.some((t) => t.tela === "monitor-proposta")
      ) {
        if (this.ROUTES.some((p) => p.path === "/financiamento/acompanhamento")) {
          this.ROUTES.splice(
            this.ROUTES.indexOf(this.ROUTES.find((p) => p.path === "/financiamento/acompanhamento")),
            1
          );
        }
      }

      if (!this.possuiModulo(16) || !this.telasDoFuncionario.some((t) => t.tela === "monitor-venda")) {
        if (this.ROUTES.some((p) => p.path === "/crm-vendas/acompanhamento")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.path === "/crm-vendas/acompanhamento")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "relatorios")) {
        if (this.ROUTES.some((p) => p.title === "Relatórios")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Relatórios")), 1);
        }
      }

      if (!this.telasDoFuncionario.some((t) => t.tela === "configuracoes")) {
        if (this.ROUTES.some((p) => p.title === "Configurações")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Configurações")), 1);
        }
      }

      if (
        !(
          this.possuiModulo(16) ||
          (this.possuiModulo(12) && (this.suporte || this.telasDoFuncionario.some((t) => t.tela === "crm_tarefa")))
        )
      ) {
        if (this.ROUTES.find((p) => p.path === "/gestao-tarefas/acompanhamento/hoje")) {
          this.ROUTES.splice(
            this.ROUTES.indexOf(this.ROUTES.find((p) => p.path === "/gestao-tarefas/acompanhamento/hoje")),
            1
          );
        }
      }
    } else if (this.integrador) {
      if (this.ROUTES.some((p) => p.path === "/gestao-tarefas/acompanhamento/hoje")) {
        this.ROUTES.splice(
          this.ROUTES.indexOf(this.ROUTES.find((p) => p.path === "/gestao-tarefas/acompanhamento/hoje")),
          1
        );
      }

      if (this.ROUTES.some((p) => p.path === "/financiamento/acompanhamento")) {
        this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.path === "/financiamento/acompanhamento")), 1);
      }

      if (this.ROUTES.some((p) => p.path === "/orcamento/acompanhamento")) {
        this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.path === "/orcamento/acompanhamento")), 1);
      }

      if (this.ROUTES.some((p) => p.path === "/crm-vendas/acompanhamento")) {
        this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.path === "/crm-vendas/acompanhamento")), 1);
      }

      if (!this.premissasSistema.habilitaMenuMontarKit) {
        if (this.ROUTES.some((m) => m.path === "/montar-kit")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((m) => m.path === "/montar-kit")), 1);
        }
      }

      if (!this.premissasSistema.habilitaMenuKitPronto || !this.mostrarKitPronto) {
        if (this.ROUTES.some((p) => p.path === "/kitfechado")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.path === "/kitfechado")), 1);
        }
      }

      if (
        !this.premissasSistema.habilitaMenuKitPronto ||
        !this.mostrarKitPronto ||
        !this.premissasSistema.usarNovoMenuKitPronto
      ) {
        if (this.ROUTES.some((p) => p.path === "/kitplus")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.path === "/kitplus")), 1);
        }
      }

      if (!this.premissasSistema.habilitaMenuKitPronto || !this.mostrarKitPronto || !this.premissasSistema.usarKitPlus2) {
        if (this.ROUTES.some((p) => p.path === "/kitplus2")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.path === "/kitplus2")), 1);
        }
      }

      if (!this.possuiModulo(2) || !this.cliente.podeVerMenuRepasse) {
        if (this.ROUTES.some((p) => p.title === "Repasses")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Repasses")), 1);
        }
      }

      if (!this.usarLojaProdutos) {
        if (this.ROUTES.some((p) => p.title === "Loja de Produtos")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Loja de Produtos")), 1);
        }
      } else {
        this.criarMenusLojas();
      }

      if (this.premissasSistema.avulsoSomenteInterno) {
        if (this.ROUTES.some((p) => p.path === "/avulso")) {
          this.ROUTES.splice(this.ROUTES.indexOf(this.ROUTES.find((p) => p.path === "/avulso")), 1);
        }
      }
    }

    if (!this.possuiModulo(15) || !this.financiamento.ativo ||
      (this.integrador && !this.usuarioLogado.podeSimular) ||
      (!this.integrador && !this.telasDoFuncionario.some((t) => t.tela === "financiamentos"))
    ) {
      if (this.ROUTES.some((p) => p.path === "/financiamento/monitor-simulacao")) {
        this.ROUTES.splice(
          this.ROUTES.indexOf(this.ROUTES.find((p) => p.path === "/financiamento/monitor-simulacao")),
          1
        );
      }
    }

    // inscreve no evento de troca de configuração
    this.configuracaoSubscription$ = this.globalService.alterouConfiguracao.subscribe((conf) => {
      this.configuracao = conf;
    });

    this.nomeDoUsuario = this.usuarioLogado.nome;

    // this.ROUTES.find(p => p.path === '/pedidos').title = this.globalService.integrador() ? 'Orçamentos' : 'Pedidos';

    this.ROUTES.forEach((p) => {
      if (!p.traco) {
        p.visivel = this.possuiPermissaoLink(p.path.substring(1));
        if (p.children) {
          p.children.forEach((f) => {
            f.visivel = this.possuiPermissaoLink(p.path.substring(1) + "/" + f.path);
          });
        }
      }
    });

    if (this.ROUTES.some((p) => p.title === "Usuário")) {
      this.ROUTES.find((p) => p.title === "Usuário").title = this.nomeDoUsuario;
    }

    if (
      this.ROUTES.some(
        (p) => p.type === "sub" && (!p.children || p.children.length === 0 || !p.children.some((f) => f.visivel))
      )
    ) {
      this.ROUTES.filter(
        (p) => p.type === "sub" && (!p.children || p.children.length === 0 || !p.children.some((f) => f.visivel))
      ).forEach((p) => {
        p.visivel = false;
      });
    }

    let achouTraco = false;

    this.ROUTES.forEach((p) => {
      if (p.path === "/kitpersonalizado") p.visivel = false;

      if (p.traco) {
        if (achouTraco) {
          p.visivel = false;
        } else {
          achouTraco = true;
          p.visivel = true;
        }
      } else {
        achouTraco = false;
      }
    });

    this.menuItems = this.ROUTES.filter((menuItem) => !menuItem.somenteMobile);
    this.menuItemsMobile = this.ROUTES.filter((menuItem) => menuItem.somenteMobile);
    if (window.matchMedia("(min-width: 960px)").matches && !this.isMac()) {
      const elemSidebar = <HTMLElement>document.querySelector(".sidebar .sidebar-wrapper");
      this.ps = new PerfectScrollbar(elemSidebar);
    }

    if (!this.integrador || !this.premissasSistema.integracaoRZK || !this.possuiRzkId) {
      this.menuItems = this.menuItems.filter((item) => item.path !== "/energy-advisor");
    }

    if (this.integrador || !this.premissasSistema.feedDeIntegradores) {
      this.menuItems = this.menuItems.filter((item) => item.path !== "/feed-integradores");
    }

    this.carregandoService.mostra("mostrarVendaAvulso");
    this.premissasService.consultarMostrarVendaAvulso().subscribe(
      (f) => {
        if (!f.valor) {
          this.menuItems = this.menuItems.filter((item) => item.path !== "/avulso");
          // this.menuItemsMobile = this.menuItemsMobile.filter(item => item.path !== '/avulso');
        }
        this.carregandoService.esconde("mostrarVendaAvulso");
      },
      (erro) => {
        this.carregandoService.esconde("mostrarVendaAvulso");
        this.notificacaoService.erro(erro);
      }
    );

    this.carregandoService.mostra("consultarUsarFidelidade");
    this.premissasService.consultarUsarFidelidade().subscribe(
      (f) => {
        if (!f.valor) {
          this.menuItems = this.menuItems.filter((item) => item.path !== "/fidelidade");
        } else {
          this.carregandoService.mostra("textoFidelidade");
          this.premissasService.textoFidelidade().subscribe(
            (vars) => {
              if (this.menuItems.some((m) => m.path === "/fidelidade"))
                this.menuItems.find((m) => m.path === "/fidelidade").title = vars.texto;
              this.carregandoService.esconde("textoFidelidade");
            },
            (erro) => {
              this.carregandoService.esconde("textoFidelidade");
              this.notificacaoService.erro(erro);
            }
          );
        }
        this.carregandoService.esconde("consultarUsarFidelidade");
      },
      (erro) => {
        this.carregandoService.esconde("consultarUsarFidelidade");
        this.notificacaoService.erro(erro);
      }
    );

    this.carregandoService.mostra("consultarNfeCobranca");
    this.premissasService.consultarNfeCobranca().subscribe(
      (f) => {
        if (!f.valor) {
          this.menuItems = this.menuItems.filter((item) => item.path !== "/monitoramento-financiamento");
        }
        this.carregandoService.esconde("consultarNfeCobranca");
      },
      (erro) => {
        this.carregandoService.esconde("consultarNfeCobranca");
        this.notificacaoService.erro(erro);
      }
    );

    this.carregandoService.mostra("consultarMonConferencia");
    this.premissasService.consultarMonConferencia().subscribe(
      (f) => {
        if (!f.valor) {
          this.menuItems = this.menuItems.filter((item) => item.path !== "/monitoramento-separacao");
        }
        this.carregandoService.esconde("consultarMonConferencia");
      },
      (erro) => {
        this.carregandoService.esconde("consultarMonConferencia");
        this.notificacaoService.erro(erro);
      }
    );

    this.carregandoService.mostra("consultarMonIntegracao");
    this.premissasService.consultarMonIntegracao().subscribe(
      (f) => {
        if (!f.valor) {
          this.menuItems = this.menuItems.filter(
            (item) =>
              item.path !== "/monitoramento-integracao" &&
              item.path !== "/monitoramento-triagem" &&
              item.path !== "/monitoramento-pendencia"
          );
        } else {
          this.carregandoService.mostra("consultarMonTriagemPendencia");
          this.premissasService.consultarMonTriagemPendencia().subscribe(
            (f) => {
              if (!f.valor) {
                this.menuItems = this.menuItems.filter(
                  (item) => item.path !== "/monitoramento-triagem" && item.path !== "/monitoramento-pendencia"
                );
              }
              this.carregandoService.esconde("consultarMonTriagemPendencia");
            },
            (erro) => {
              this.carregandoService.esconde("consultarMonTriagemPendencia");
              this.notificacaoService.erro(erro);
            }
          );
        }

        this.carregandoService.esconde("consultarMonIntegracao");
      },
      (erro) => {
        this.carregandoService.esconde("consultarMonIntegracao");
        this.notificacaoService.erro(erro);
      }
    );

    this.carregandoService.mostra("consultarMonConferenciaTecnica");
    this.premissasService.consultarMonConferenciaTecnica().subscribe(
      (f) => {
        if (!f.valor) {
          this.menuItems = this.menuItems.filter((item) => item.path !== "/monitoramento-conferencia");
        }
        this.carregandoService.esconde("consultarMonConferenciaTecnica");
      },
      (erro) => {
        this.carregandoService.esconde("consultarMonConferenciaTecnica");
        this.notificacaoService.erro(erro);
      }
    );

    this.carregandoService.mostra("consultarMonVerificacao");
    this.premissasService.consultarMonVerificacao().subscribe(
      (f) => {
        if (!f.valor) {
          this.menuItems = this.menuItems.filter((item) => item.path !== "/monitoramento-verificacao");
        }
        this.carregandoService.esconde("consultarMonVerificacao");
      },
      (erro) => {
        this.carregandoService.esconde("consultarMonVerificacao");
        this.notificacaoService.erro(erro);
      }
    );

    this.carregandoService.mostra("consultarMonAnaliseFinanceira");
    this.premissasService.consultarMonAnaliseFinanceira().subscribe(
      (f) => {
        if (!f.valor) {
          this.menuItems = this.menuItems.filter((item) => item.path !== "/monitoramento-analise-financeira");
        }
        this.carregandoService.esconde("consultarMonAnaliseFinanceira");
      },
      (erro) => {
        this.carregandoService.esconde("consultarMonAnaliseFinanceira");
        this.notificacaoService.erro(erro);
      }
    );

    this.carregandoService.mostra("consultarMonFaturamento");
    this.premissasService.consultarMonFaturamento().subscribe(
      (f) => {
        if (!f.valor) {
          this.menuItems = this.menuItems.filter((item) => item.path !== "/monitoramento-faturamento-tec");
        }
        this.carregandoService.esconde("consultarMonFaturamento");
      },
      (erro) => {
        this.carregandoService.esconde("consultarMonFaturamento");
        this.notificacaoService.erro(erro);
      }
    );

    this.carregandoService.mostra("textoKitFechado");

    this.premissasService.textoKitFechado().subscribe(
      (vars) => {
        if (this.menuItems.some((m) => m.path === "/kitfechado"))
          this.menuItems.find((m) => m.path === "/kitfechado").title = vars.texto;

        // this.menuItemsMobile.find(m => m.path === '/kitfechado').title = vars.texto;
        this.carregandoService.esconde("textoKitFechado");
      },
      (erro) => {
        this.carregandoService.esconde("textoKitFechado");
        this.notificacaoService.erro(erro);
      }
    );

    this.carregandoService.mostra("textoNovoKitPronto");

    this.premissasService.textoNovoKitPronto().subscribe(
      (vars) => {
        if (this.menuItems.some((m) => m.path === "/kitplus"))
          this.menuItems.find((m) => m.path === "/kitplus").title = vars.texto;

        this.carregandoService.esconde("textoNovoKitPronto");
      },
      (erro) => {
        this.carregandoService.esconde("textoNovoKitPronto");
        this.notificacaoService.erro(erro);
      }
    );

    this.carregandoService.mostra("textoKitPlus2");
    this.premissasService.textoNovoKitPlus2().subscribe(
      (vars) => {
        if (this.menuItems.some((m) => m.path === "/kitplus2"))
          this.menuItems.find((m) => m.path === "/kitplus2").title = vars.texto;

        this.carregandoService.esconde("textoKitPlus2");
      },
      (erro) => {
        this.carregandoService.esconde("textoKitPlus2");
        this.notificacaoService.erro(erro);
      }
    );

    this.carregandoService.mostra("textoMonteSeuKit");
    this.premissasService.textoMonteSeuKit().subscribe(
      (vars) => {
        if (this.menuItems.some((m) => m.path === "/montar-kit"))
          this.menuItems.find((m) => m.path === "/montar-kit").title = vars.texto;

        this.carregandoService.esconde("textoMonteSeuKit");
      },
      (erro) => {
        this.carregandoService.esconde("textoMonteSeuKit");
        this.notificacaoService.erro(erro);
      }
    );

    this.carregandoService.mostra("textoAvulso");
    this.premissasService.textoAvulso().subscribe(
      (vars) => {
        if (this.menuItems.some((m) => m.path === "/avulso"))
          this.menuItems.find((m) => m.path === "/avulso").title = vars.texto;

        this.carregandoService.esconde("textoAvulso");
      },
      (erro) => {
        this.carregandoService.esconde("textoAvulso");
        this.notificacaoService.erro(erro);
      }
    );

    this.carregandoService.mostra("buscarUsarTabelaDeFrete");
    this.premissasService.consultarTxVendaDireta().subscribe(
      (f) => {
        if (
          (f.cif === undefined || f.cif === null || f.cif === 0) &&
          (f.fob === undefined || f.fob === null || f.fob === 0)
        ) {
          this.menuItems = this.menuItems.filter((item) => item.path !== "/repasses");
        }
        this.carregandoService.esconde("buscarUsarTabelaDeFrete");
      },
      (erro) => {
        this.carregandoService.esconde("buscarUsarTabelaDeFrete");
        this.notificacaoService.erro(erro);
      }
    );

    this.carregandoService.mostra("consultarMultiFornecedores");
    this.premissasService.consultarMultiFornecedores().subscribe(
      (f) => {
        if (!f.valor) {
          this.menuItems = this.menuItems.filter((item) => item.path !== "/fechamento-financeiro");
        } else if (this.integrador) {
          this.menuItems = this.menuItems.filter((item) => item.path !== "/avulso");
        }
        this.carregandoService.esconde("consultarMultiFornecedores");
      },
      (erro) => {
        this.carregandoService.esconde("consultarMultiFornecedores");
        this.notificacaoService.erro(erro);
      }
    );
  }

  possuiModulo(modulo: Number) {
    return this.modulosAtivos.some((p) => p === modulo);
  }

  async buscarModulosAtivos() {
    try {
      this.carregandoService.mostra("buscarModulosAtivos");

      this.modulosAtivos = await this.premissasService.consultarModulosAtivos().toPromise();

      this.carregandoService.esconde("buscarModulosAtivos");
    } catch (erro) {
      this.carregandoService.esconde("buscarModulosAtivos");
      this.notificacaoService.erro(erro);
    }
  }

  async buscarMostrarKitPronto() {
    try {
      this.carregandoService.mostra("buscarMostrarKitPronto");

      this.mostrarKitPronto = (await this.segmentacaoService.consultarMostrarKitPronto().toPromise()).valor;

      this.carregandoService.esconde("buscarMostrarKitPronto");
    } catch (erro) {
      this.carregandoService.esconde("buscarMostrarKitPronto");
      this.notificacaoService.erro(erro);
    }
  }

  async buscarFinanciamento() {
    try {
      this.carregandoService.mostra("buscarFinanciamento");

      this.financiamento = (await this.financiamentoService.buscar().toPromise()).result;

      this.carregandoService.esconde("buscarFinanciamento");
    } catch (erro) {
      this.carregandoService.esconde("buscarFinanciamento");
      this.notificacaoService.erro(erro);
    }
  }

  async buscarTelasDoFuncionario() {
    try {
      this.carregandoService.mostra("buscarTelasDoFuncionario");

      this.telasDoFuncionario = await this.funcionarioService.consultarTelasDoFuncionario().toPromise();

      this.carregandoService.esconde("buscarTelasDoFuncionario");
    } catch (erro) {
      this.carregandoService.esconde("buscarTelasDoFuncionario");
      this.notificacaoService.erro(erro);
    }
  }

  async buscarCliente() {
    try {
      this.carregandoService.mostra("buscarCliente");

      this.cliente = await this.clienteService.consultarPorIdCliente(this.idIntegrador, true).toPromise();
      this.carregandoService.esconde("buscarCliente");
    } catch (erro) {
      this.carregandoService.esconde("buscarCliente");
      this.notificacaoService.erro(erro);
    }
  }

  possuiPermissaoLink(link) {
    return (
      this.autenticacaoService.logado() &&
      this.ANGULAR_ROUTES &&
      this.ANGULAR_ROUTES[0] &&
      this.ANGULAR_ROUTES[0].children &&
      (!this.ANGULAR_ROUTES[0].children.some((p) => this.caminhoSistema + p.path === link) ||
        this.ANGULAR_ROUTES[0].children.some(
          (p) =>
            this.caminhoSistema + p.path === link &&
            p.data &&
            p.data.roles &&
            this.autenticacaoService.roleMatch(p.data.roles, this.usuarioLogado.roles)
        ))
    );
  }

  updatePS(): void {
    if (window.matchMedia("(min-width: 960px)").matches && !this.isMac()) {
      this.ps.update();
    }
  }

  isMac(): boolean {
    let bool = false;
    if (navigator.platform.toUpperCase().indexOf("MAC") >= 0 || navigator.platform.toUpperCase().indexOf("IPAD") >= 0) {
      bool = true;
    }
    return bool;
  }

  sair() {
    // this.autenticacaoService.logout();
    this.router.navigate(["/login"]);
  }

  financiamentoGel() {
    window.open("https://gelsolar.com.br/meu-financiamento-solar/", "_blank");
  }

  executaMetodo(metodo) {
    switch (metodo) {
      case "sair":
        this.sair();
        break;

      case "financiamentoGel":
        this.financiamentoGel();
        break;

      default:
        break;
    }
  }

  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    if (this.configuracaoSubscription$ !== undefined) {
      this.configuracaoSubscription$.unsubscribe();
    }
  }

  buscarCodEverest(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra("buscarCodEverst");
      this.premissasService.consultarCodEverest().subscribe(
        (codEverest) => {
          this.codEverest = codEverest.valor;
          this.carregandoService.esconde("buscarCodEverst");
          resolve();
        },
        (err) => {
          this.carregandoService.esconde("buscarCodEverst");
          this.notificacaoService.erro(err);
          reject();
        }
      );
    });
  }

  buscarPremissaUsarCRM() {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra("buscarPremissaUsarCRM");
      this.premissasService.consultarUsarCRM().subscribe(
        (dados) => {
          this.usarCRM = dados.valor;

          this.carregandoService.esconde("buscarPremissaUsarCRM");
          resolve();
        },
        (erro) => {
          this.carregandoService.esconde("buscarPremissaUsarCRM");
          this.notificacaoService.erro(erro);
          reject();
        }
      );
    });
  }

  buscarIdentidadeVisual() {
    this.carregandoService.mostra("buscarIdentidadeVisual");

    this.identidadeVisualService.consultarIdentidadeVisual().subscribe(
      (idVisual) => {
        this.idVisual = idVisual;

        localStorage.setItem("idVisual", JSON.stringify(idVisual));

        this.carregandoService.esconde("buscarIdentidadeVisual");
      },
      (erro) => {
        this.carregandoService.esconde("buscarIdentidadeVisual");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissaUsarLojaProdutos() {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra("buscarPremissaUsarLojaProdutos");

      this.premissasService.consultarUsarLojaProdutos().subscribe(
        (p) => {
          this.usarLojaProdutos = p.valor;
          this.carregandoService.esconde("buscarPremissaUsarLojaProdutos");
          resolve();
        },
        (erro) => {
          this.carregandoService.esconde("buscarPremissaUsarLojaProdutos");
          this.notificacaoService.erro(erro);
          reject(erro);
        }
      );
    });
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra("buscarPremissasSistema");
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde("buscarPremissasSistema");
    }
  }

  async buscarLojas() {
    try {
      this.carregandoService.mostra("buscarLojas");

      const queryFilter = this.queryFilterService
        .getQueryBuilder()
        .addCondition("situacao", "=", TipoSituacaoCadastral.Ativo)
        .build();

      this.lojas = (await this.lojaConfigService.buscarTodos(queryFilter).toPromise()).results;
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde("buscarLojas");
    }
  }

  async consultarPossuiRzkId() {
    try {
      this.carregandoService.mostra("consultarPossuiRzkId");
      this.possuiRzkId = (await this.rzkService.possuiRzkId(this.usuarioLogado.id).toPromise()).valor;
    } catch (erro) {
      this.notificacaoService.erro(erro);
      console.log("erro:", erro);
    } finally {
      this.carregandoService.esconde("consultarPossuiRzkId");
    }
  }

  criarMenusLojas() {
    let index = this.ROUTES.indexOf(this.ROUTES.find((p) => p.title === "Loja de Produtos"));
    this.ROUTES.splice(index, 1);

    for (const loja of this.lojas) {
      const menu = {
        path: `/loja-de-produtos/${loja.id}`,
        title: loja.nome,
        type: "link",
        icontype: loja.icone !== null && loja.icone !== undefined && loja.icone ? loja.icone : "storefront",
      };

      this.ROUTES.splice(index, 0, menu);
      index++;
    }
  }
}
